




































































































import { Component, Vue } from 'vue-property-decorator';
import axios, { AxiosResponse } from 'axios';
import Cookies from 'js-cookie';
import storage from 'baimahu/storage';
const numeral = require('numeral');
const { VUE_APP_FCREST: FCREST } = process.env;
const _ = {
  each: require('lodash/each'),
  map: require('lodash/map'),
};
const WARE_STATUS = [
  {
    id: 1,
    value: '上架中',
  },
  {
    id: 2,
    value: '已售罄',
  },
  {
    id: 3,
    value: '仓库中',
  },
];
const API = {
  ware: `${FCREST}/promotion/shang/activity/specify-ware/ware`, // 商品列表(get) || 删除商品(delete) || 提交商品(post)
  search: `${FCREST}/promotion/shang/ware`, // 搜索商品
};
function getWareListFormat(remote?: any) {
  remote = remote || {};
  return {
    data: remote.data || [],
    last_page: remote.last_page || 0,
    per_page: remote.per_page || 0,
    total: remote.total || 0,
    current_page: remote.current_page || 0,
  };
}
@Component
export default class ActivityWare extends Vue {
  assgin_ware_list: any = getWareListFormat(); // 指定商品列表
  activity_id: string = ''; // 活动id
  active_ware_status: number | string = ''; // 当前选中的商品状态
  is_loading: boolean = false;
  is_show_add_modal: boolean = false; // 是否展示‘指定商品’模态窗
  page: number = 1; // 搜索商品页码
  search_ware_name: string = ''; // 模态窗商品名称
  selectedRowKeys: any = []; // 当前选中的商品
  ware_list: any = []; // 商品数据

  get wareStatus() {
    return WARE_STATUS;
  }

  // 获取商品列表
  async query() {
    this.is_loading = true;
    const res = await this.$axios.get(
      `${API.ware}?activity_id=${this.activity_id}`,
    );
    this.is_loading = false;
    if (res.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    _.map(res.data.data, (item: any) => {
      item.price = numeral(item.price || 0)
        .divide(100)
        .value();
    });
    this.ware_list = res.data.data;
  }

  // 点击删除商品按钮
  eraseWare(item: any, index: number) {
    this.$confirm({
      title: '是否确认删除商品',
      onOk: async () => {
        this.is_loading = true;
        const res = await this.$axios.delete(
          `${API.ware}/${item.id}?activity_id=${this.activity_id}`,
          {
            data: {
              activity_id: +this.activity_id,
              id: item.id,
            },
          },
        );
        this.is_loading = false;
        if (res.status !== 200) {
          this.$message.error(res.data.message);
          return;
        }
        await this.query();
      },
    });
  }

  // 关闭模态窗
  closeModal() {
    this.is_show_add_modal = false;
    this.active_ware_status = '';
    this.search_ware_name = '';
  }

  // 点击指定商品按钮
  clickAssignBtn() {
    this.is_show_add_modal = true;
    this.searchWare();
    _.each(this.ware_list, (item: any) => {
      this.selectedRowKeys.push(item.ware_id);
    });
  }

  // 点击搜索按钮
  async searchWare(page: number = 1) {
    const profile = storage.getItem('profile') || {};
    const merchant_id = profile.merchant_id || '';
    this.is_loading = true;
    const res = await this.$axios.get(
      `${API.search}?page=${page}&status=${this.active_ware_status}&name=${this.search_ware_name}&merchant_id=${merchant_id}`,
    );
    this.is_loading = false;
    if (res.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    _.map(res.data.data.data, (item: any) => {
      item.price = numeral(item.price || 0)
        .divide(100)
        .value();
    });
    this.assgin_ware_list = getWareListFormat(res.data.data);
  }

  // 提交指定商品
  async createWare() {
    this.is_loading = true;
    const res = await this.$axios.post(API.ware, {
      activity_id: this.activity_id,
      ware_id: this.selectedRowKeys,
    });
    this.is_loading = false;
    if (res.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.is_show_add_modal = false;
    this.query();
    this.$message.success('指定商品成功');
  }

  // 修改模态窗父节点
  getPopupContainer() {
    return document.getElementById('activity-ware');
  }

  // 控制页码显示
  paginationOption(data: any) {
    return {
      total: data.total || 0,
      showTotal: (total: number) => `共${data.total}条，每页${data.per_page}条`,
      pageSize: data.per_page || 1,
      current: data.current_page || 1,
    };
  }

  handleChangePaging(pagination: any) {
    const next_page = pagination.current;
    this.searchWare(next_page);
  }

  // 勾选商品
  handleWareSelect(selectedRowKeys: any) {
    this.selectedRowKeys = selectedRowKeys;
  }

  async created() {
    this.activity_id = this.$route.query.activity_id as string;
    await this.query();
    await this.searchWare();
  }
}
